import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { PricingProfileAction } from '@cbridge-packages/pricing-profile';

export const toggleViewPricingProfileSidebarEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    PricingProfileAction.update.done,
  ),
  map(() => {
    return DetailsSidebarAction.toggleEdit();
  }),
);
